import SearchOrigin from '@alltrails/analytics/enums/SearchOrigin';
import { AlgoliaSearchBox } from '@alltrails/modules/AlgoliaSearch';
import '@alltrails/modules/AlgoliaSearch/index.css';
import { LanguageSupportUtil } from '../../../../../utils/language_support_util';

const createReactClass = require('create-react-class');

const FullscreenBreadcrumbBar = createReactClass({
  render() {
    const bullet = <span>&nbsp; &#8226; &nbsp;</span>;
    const breadcrumbItems = this.props.items.map(
      function (item, i) {
        if (item.link && item.link != null) {
          const link = LanguageSupportUtil.wrapUrlSafe(item.link, this.props.context.languageRegionCode);
          return (
            <li className={item.class} key={`breadcrumb-${item.label}`}>
              {i > 0 && bullet}
              <a href={link}>{item.label}</a>
            </li>
          );
        }
        return (
          <li className={item.class} key={`breadcrumb-${item.label}`}>
            {i > 0 && bullet}
            {item.label}
          </li>
        );
      }.bind(this)
    );
    return (
      <div>
        <div id="breadcrumb-bar">
          <AlgoliaSearchBox
            className="algolia-search-box"
            configs={global.__AT_DATA__.algoliaConfig}
            includeGuides={global.__AT_DATA__.features.includes('guides')}
            isMobileBrowser={this.props.context.mobileBrowser}
            languageRegionCode={this.props.context.languageRegionCode}
            navigateOnSelect
            numResults={this.props.isMobileWidth ? 8 : 10}
            placeholder={this.props.intl.formatMessage({ defaultMessage: 'Enter a city, park or trail name' })}
            searchOrigin={SearchOrigin.ExploreMapView}
            searchTypes={this.props.typeSubsets}
            size="sm"
            testId="breadcrumbs-search-box"
            user={this.props.context.currentUser}
          />
          <ul id="breadcrumb-list">{breadcrumbItems}</ul>
        </div>
      </div>
    );
  }
});

export { FullscreenBreadcrumbBar };
